import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Box,
  Card,
  CardContent,
  TextField,
} from '@mui/material';
import { green, red } from '@mui/material/colors';
import EditIcon from '@mui/icons-material/Edit';
import HearingIcon from '@mui/icons-material/Hearing';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import WarningIcon from '@mui/icons-material/Warning';
import { useAuth } from '../../Auth/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { can } from '../../Conections/LogConections';
import { ListGruopDataAPI } from '../../Conections/AcademicConection';

const GroupList = () => {
  const { getToken, getCompany } = useAuth();
  const goTo = useNavigate();

  const [grupos, setGrupos] = useState([]);
  const [gruposFiltrados, setGruposFiltrados] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [grupoAEliminar, setGrupoAEliminar] = useState(null);
  const [busqueda, setBusqueda] = useState('');

  useEffect(() => {
    async function reloaduser() {
      if (getToken()) {
        const permisionCan = await can(getToken(), getCompany(), "/academic/listgroup");
        if (permisionCan) {
          const gruposSimulados = await ListGruopDataAPI(getToken(), getCompany());
          setGrupos(gruposSimulados);
          setGruposFiltrados(gruposSimulados);
        }
        else {
          goTo("/dashboard");
        }
      }
      else {
        goTo("/login");
      }
    };
    reloaduser();
  }, [getCompany, getToken, goTo]);

  useEffect(() => {
    const resultadosBusqueda = grupos.filter(grupo =>
      grupo.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
      grupo.descripcion.toLowerCase().includes(busqueda.toLowerCase())
    );
    setGruposFiltrados(resultadosBusqueda);
  }, [busqueda, grupos]);

  const handleEditar = (id) => {
    goTo("/academic/editgroup/"+id);
  };

  const handleEliminar = (grupo) => {
    setGrupoAEliminar(grupo);
    setOpenDialog(true);
  };

  const confirmarEliminacion = () => {
    if (grupoAEliminar) {
      console.log('Eliminar grupo con id:', grupoAEliminar.id);
      // Aquí iría la lógica para eliminar el grupo
      const gruposActualizados = grupos.filter(g => g.id !== grupoAEliminar.id);
      setGrupos(gruposActualizados);
      setGruposFiltrados(gruposActualizados);
    }
    setOpenDialog(false);
    setGrupoAEliminar(null);
  };

  const handleMostrar = (id) => {
    goTo("/academic/showgroup/"+id);
  };

  const handleLista = (id) => {
    goTo("/academic/studentlist/"+id);
  };

  const handleListaShow = (id) => {
    goTo("/academic/studentlistshow/"+id);
  };

  const handleBusquedaChange = (event) => {
    setBusqueda(event.target.value);
  };

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <Typography variant="h4" component="h2" align="center" gutterBottom>
        Listado de Grupos
      </Typography>
      <Card>
        <CardContent>
          <TextField
            fullWidth
            label="Buscar grupos"
            variant="outlined"
            value={busqueda}
            onChange={handleBusquedaChange}
            sx={{ mb: 2 }}
          />
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="tabla de grupos">
              <TableHead>
                <TableRow>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Descripción</TableCell>
                  <TableCell>Visible</TableCell>
                  <TableCell align="center">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {gruposFiltrados.map((grupo) => (
                  <TableRow key={grupo.id}>
                    <TableCell>{grupo.nombre}</TableCell>
                    <TableCell>{grupo.descripcion}</TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          backgroundColor: grupo.show ? green[100] : red[100],
                          color: grupo.show ? green[800] : red[800],
                          p: 1,
                          borderRadius: 1,
                          display: 'inline-block',
                        }}
                      >
                        {grupo.show ? 'Sí' : 'No'}
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      <IconButton onClick={() => handleEditar(grupo.id)} color="default">
                        <EditIcon />
                      </IconButton>
                      {/*<IconButton onClick={() => handleEliminar(grupo)} color="default">
                        <DeleteIcon />
                      </IconButton>*/}
                      <IconButton onClick={() => handleListaShow(grupo.id)} color="default">
                        <ViewTimelineIcon />
                      </IconButton>
                      <IconButton onClick={() => handleLista(grupo.id)} color="default">
                        <HearingIcon />
                      </IconButton>
                      <IconButton onClick={() => handleMostrar(grupo.id)} color="default">
                        <VisibilityIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent sx={{ textAlign: 'center' }}>
          <WarningIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
          <DialogTitle id="alert-dialog-title">
            {"¿Está seguro de que desea eliminar este grupo?"}
          </DialogTitle>
          <DialogContentText id="alert-dialog-description">
            Esta acción no se puede deshacer. Se eliminará permanentemente el grupo
            {grupoAEliminar && ` "${grupoAEliminar.nombre}"`}.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
          <Button onClick={() => setOpenDialog(false)} variant="contained" color="primary">
            Cancelar
          </Button>
          <Button onClick={confirmarEliminacion} variant="contained" color="error" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default GroupList;